/**
 * Functions for wpsl single page
 */
(function ($) {
    'use strict';

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function initTab() {
        var pagetitle = $('title').text();

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            var href = $(e.delegateTarget).attr('aria-controls');
            var theurl = location.origin + location.pathname + '?tab=' + href;

            window.history.pushState('obj', pagetitle, theurl);

            // tips
            $('.tip-item').hide();
            var tip = $('.' + href + '-tips').fadeIn();
        });

        $('a.matab').on('click', function (e) {
            e.preventDefault();

            var that = $(this);
            var tab = that.data('target');

            var tagetTab = $('ul[role=tablist] a[href="#' + tab + '"]');
            if (tagetTab.length > 0) {
                tagetTab.tab('show');
            }
        });
    }

    function initTabControl() {
        var tab = getUrlParameter('tab');
        if (!tab){
            tab = 'infomation';
        }
        var tagetTab = $('ul[role=tablist] a[href="#' + tab + '"]');
        if (tagetTab.length > 0) {
            tagetTab.tab('show');
        } else {
            $('ul[role=tablist] a[role=tab]:first-child').tab('show');
        }
    }

    function initFormContact(){
        var inputCentre = $('form [type=hidden][name=centre]');
        if (inputCentre.length > 0){
            inputCentre.val($('.page-title').text());
        }
    }

    function initStoreWapper() {
        var stwp = $('.store-wapper');
        if (stwp.length > 0) {
            var links = $('#primary-menu > li > a');
            $.each(links, function (indx, el) {
                var href = $(el).attr('href');
                var checkInvolvel = href.indexOf('find-a-centre/');
                if (checkInvolvel > 0) {
                    $(el).closest('li').addClass('current-page-ancestor');
                }
            });
        }
    }

    function initFormSearch() {
        var formsearch = $('.form-search-center');
        if (formsearch.length > 0) {
            formsearch.on('change', '.centre-boxing [type=checkbox]', function () {
                var that = $(this);
                if (that.is(':checked')) {
                    formsearch.find('.centre-boxing [type=checkbox]:checked').each(function (indx, check) {
                        if ($(check).attr('id') != that.attr('id')) {
                            $(check).prop('checked', false); // Unchecks it
                        }
                    })
                }
            });
        }
    }

    // centres page
    function listCentres() {
        var centre_address = $('#centre_addresses article');
        if (centre_address.length > 0) {
            centre_address.on('click', 'h4', function () {
                var that = $(this);

                var article = that.closest('article');
                if (!article.hasClass('active')) {
                    centre_address.removeClass('active');
                }

                article.addClass('active');
            });
        }
    }
    
    function newAndEvents() {
        var list = $('.new-events').find('span');

        var count = list.length;
        for (var i = 0; i < count; i++) {
            var elm = $(list[i]);
            if (i <= count - 3){
                elm.html(elm.html() + ', ');
            }else if (i = count - 3){
                elm.html(elm.html() + ' and ');
            }
        }
    }

    initTab();
    initTabControl();
    initFormContact();
    initStoreWapper();
    initFormSearch();
    listCentres();
    newAndEvents();

})(jQuery);

var lastExp= '';

function onSearchButtonBinding() {
    var inputVal = $('#wpsl-search-input').val();
    var pagetitle = $('title').text();


    // var theurl = location.origin + location.pathname + '?scentre=' + inputVal;
    // window.history.pushState('obj', pagetitle, encodeURI(theurl));
}

function fitler_centres(list_centres) {
    var checkbox = $('.form-search-center .filter-boxing :checked');


    if (checkbox.length != 1) {
        return list_centres;
    } else {
        var newlist = [];
        var textfilter = checkbox.data('filter');

        $.each(list_centres, function (index, element) {
            var valid = false;

            if (element.services) {

                $.each(element.services, function (idx, service) {
                    if (service.name == textfilter) {
                        valid = true;
                    }
                });
            }

            if (valid) {
                newlist.push(element);
            }
        });

        return newlist;
    }
}

function getCentreExp(e) {
    var wp = e.parents('.wpsl-direction-wrap');
    lastExp = $(wp).find('.excerpt').text();
}

function appendLastExp() {
    if (lastExp){
        $('#wpsl-direction-details').append('<p>' + lastExp + '</p>');
    }
}